
import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatInput, MatInputModule } from '@angular/material/input';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { UserService } from 'src/app/services/api/users/user.service';
import { ButtonComponent } from 'ui-library';
import { AuthService } from '../../../services/core/auth.service';

@Component({
  selector: 'reset-password',
  imports: [
      ButtonComponent,
        CommonModule,
        FormsModule,
        MatCardModule,
        MatFormFieldModule,
        MatInputModule,
        MatIcon,
        MatInput,
        RouterLink,
        ReactiveFormsModule,
        TranslateModule
    ],
  templateUrl: './reset-password.page.html',
  styleUrls: ['./reset-password.page.scss'],
})
export class ResetPasswordPage implements OnInit, OnDestroy {
  loginForm!: FormGroup;
  login: any = { password: '', confirmPassword: '' };
  error: string = "";
  id: string = "";
  message: string = "";
  submitted = false;
  success: boolean = false;
  destroy$ = new Subject<void>();
  passwordCriteria = {
    length: false,
    uppercase: false,
    lowercase: false,
    digit: false,
    noSpaces: false
  };
  reachedCriteria = {
    length: false,
    uppercase: false,
    lowercase: false,
    digit: false,
    noSpaces: false
  };

  constructor(
    private fb: FormBuilder,
    private userService: UserService,
    private authService: AuthService,
    public router: Router,
    private route: ActivatedRoute,
    private translate: TranslateService) {
    this.translate.setDefaultLang(this.userService.initLanguage());

    this.translate.get('title.reset-password').toPromise().then(() => {
    });
  }

  ngOnInit() {
    const { id } = this.route.snapshot.queryParams;
    this.id = id;
    this.loginForm = this.fb.group({
      password: [null, Validators.required],
      confirmPassword: [null, Validators.required],
    })
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  setPassword() {

    this.error = "";
    this.submitted = true;

    if (!this.id)
      this.error = "login.wrong_url"

    if (this.loginForm.valid) {
      let pattern = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?!.*\s).*$/;

      if (this.loginForm.value.password !== this.loginForm.value.confirmPassword) {
        this.error = "login.not_matching";
      }
      else if (this.loginForm.value.password.length < 8 || !this.validText(this.loginForm.value.password, pattern)) {
        this.error = "login.password_incorrect"
      }

      if (this.error) return;

      let data = {
        id: this.id,
        password: this.loginForm.value.password,
        confirmPassword: this.loginForm.value.confirmPassword
      }

      this.authService.resetPassword(data).pipe(takeUntil(this.destroy$)).subscribe(
        data => {
          this.message = "login.success"
          this.success = true;
        },
        error => {
          console.error(error);
          this.error = error.error?.error?.includes('reset link') ? "login.error.reset_password" : "login.error.server";
          this.success = false;
        });
    }
  }

  onLogin() {
    this.router.navigateByUrl('/login');
  }

  validText(text: string, pattern: RegExp) {
    return String(text).match(pattern);
  }

  onClickHome() {
    this.router.navigateByUrl("/");
  }

  checkPasswordCriteria() {
    const password = this.loginForm.get('password')?.value;
    this.passwordCriteria.length = password && password.length >= 8;
    this.passwordCriteria.uppercase = /[A-Z]/.test(password);
    this.passwordCriteria.lowercase = /[a-z]/.test(password);
    this.passwordCriteria.digit = /\d/.test(password);
    this.passwordCriteria.noSpaces = !/\s/.test(password);
    this.updateReachedCriteria();
  }

  updateReachedCriteria() {
    for (const key of Object.keys(this.passwordCriteria) as (keyof typeof this.passwordCriteria)[]) {
      if (this.passwordCriteria[key]) this.reachedCriteria[key] = true;
    }
  }

}
